import { handle401GraphqlErrorSeller } from 'Utils/seller/sellerUtils';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS } from 'Utils/request/requestDictionary';
import { createOptimisticAction } from 'Store/utils/createAction';
import type { FetchPrebookingTravelersParams } from './prebookingform.queries';
import { travelerProfilesQuery } from './prebookingform.queries';
export const FETCH_PREBOOKING_TRAVELERS = 'FETCH_PREBOOKING_TRAVELERS';
export function fetchPrebookingTravelers(
  params: FetchPrebookingTravelersParams,
  appContext: AppContext,
) {
  return (dispatch: ReduxDispatch) => {
    if (!params.adults || params.adults.length === 0) {
      return Promise.reject();
    }

    const query = travelerProfilesQuery(params);
    const promise = graphQLClient
      .runNoCacheQuery(query, appContext, {
        requestName: CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS,
      })
      .catch((error) => {
        if (error.errors && error.errors.some((e) => e.statusCode === 401)) {
          handle401GraphqlErrorSeller(error, appContext);
        }

        return {};
      });
    return dispatch(
      createOptimisticAction(FETCH_PREBOOKING_TRAVELERS, params, {
        optimist: true,
        promise,
      }),
    );
  };
}
